var utils = {
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    },
    formDate:{
        WorkName: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Cardid: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Sex:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        NATION:{
            'name':'民族','value':'',option:'NATION','showSelect':true,'select':
            ['汉族','少数民族','外籍'],
        },
        MEDULEVEL:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            // ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
            ['博士研究生','硕士研究生','本科','大专','中专'],
        },
        MEDUSPEC:{
            'name':'专业','value':'',option:'education','showSelect':true,'select':['药学','中药学','相关专业'],
        },
        sort: {
            'name':'证书类型','value':'',option:'certificate','showSelect':true,'select':['执业药师','从业药师'],
        },
        ExtentOne:{
            'name':'执业类别','value':'',option:'operation','showSelect':true,'select':['药学','中药学','药学和中药学'],
        },
        QualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        ATTEYEAR: {
            'name':'考取年份','value':'','placeholder':'请填写，如：考试年月',option:'time','showSelect':false
        },
        zQualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        zATTEYEAR: {
            'name':'中药证书批准时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        NATIVEPLACE: {
            'name': '执业地区','value':'','placeholder':'请填写','option':'userName','showSelect':true,'select':[
                '石家庄','衡水','唐山','承德','张家口','秦皇岛','廊坊','保定','沧州','衡水','邢台','邯郸','其它']
        },
        ExtentTwo:{
            'name':'执业范围','value':'',option:'operatorScope','showSelect':true,'select':
            ['生产','批发','零售','使用','机关','院校','检验','无'],
        },
        WorkUnit:{
            'name':'工作单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        HANDSETPHONE:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },
        MEDUSCHOOL:{
            'name':'毕业学校','value':'','placeholder':'请填写',option:'school','showSelect':false
        },
        MEDUTIME:{
            'name':'毕业时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        zxsj:{
            'name':'注销时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        rdnf:{
            'name':'认定年份','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        technicOne:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','员级','无'],
        },
        JOBLEVEL:{
            'name':'职务','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        WorkStat:{
            'name':'从事岗位','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        address:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        postalcode:{
            'name':'邮政编码','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        LINKPHONE:{
            'name':'单位电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        email:{
            'name':'E-mail','value':'','placeholder':'请填写',option:'email','showSelect':false
        },
        grjl:{
            'name':'个人简历','value':'','placeholder':'请填写',option:'email','showSelect':false,typpe:'textarea'
        },
        byzpic:{
            'name':'毕业证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zgzpic:{
            'name':'资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        POLITICS:{
            'name':'政治面貌','value':'','placeholder':'请填写',option:'email','showSelect':true,'select':['党员',
        '团员','民主人士','群众']
        },
        zhuangtai:{
            'name':'执业状态','value':'','placeholder':'请填写',option:'email','showSelect':true,'select':[]
        },
        zcdw:{
            'name':'注册单位','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        zzzbh:{
            'name':'注册证号','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        REGISTERTIME: {
            'name':'注销时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        jg: {
            'name':'籍贯','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
        stzw: {
            'name':'社团职务','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
      
      },
      changefocus(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        if(isAndroid){
          setTimeout(function() {
           document.activeElement.scrollIntoViewIfNeeded();
           document.activeElement.scrollIntoView();
          }, 500);       
        }
    },
    changeBlur(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if(isIOS){
          setTimeout(() => {
            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 200)
        }
    },
   IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            return false
        } else if(isEdge) {
            return false//edge
        } else if(isIE11) {
            return true; //IE11  
        }else{
            return true;//不是ie浏览器
        }
    },
      enrollStr (str) {
        let str2 = ''
        if (str === 'face') {
            str2 = '函授'
        } else if (str === 'online') {
            str2 = '网络'
        } else if (str === 'repair') {
            str2 = '补修'
        }
        return str2
      },
      clear () {
        window.localStorage.clear();
      },
      token: {
        set (token) {
              window.localStorage.setItem("token", token);
          },
          get () {
              return window.localStorage.getItem('token');
          },
        remove () {
          window.localStorage.removeItem('token')
        }
      },
      news: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("newsIndex", str);
        },
        get () {
          return window.localStorage.getItem('newsIndex');
        },
        setList (str) {
            window.localStorage.setItem("Keyword", str);
        },
        getList () {
            return   window.localStorage.getItem("Keyword");
        }
      },
      userName: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("userName", str);
        },
        get () {
          return window.localStorage.getItem('userName');
        },
      },
      courseId: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("courseNum", str);
        },
        get () {
          return window.localStorage.getItem('courseNum');
        },
      },
      enroll: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("enrollName", str);
        },
        get () {
          return window.localStorage.getItem('enrollName');
        },
      },
      info: {
        set (str) { // 获取详细的新闻
         window.localStorage.setItem("info", str);
        },
        get () {
         return window.localStorage.getItem('info');
        }, 
      },
      quwstions2020:[
      ]
    }
    export default utils
    


// WEBPACK FOOTER //
// ./src/utils/index.js